import { render, staticRenderFns } from "./LMSDashboard.vue?vue&type=template&id=39229900&scoped=true&"
import script from "./LMSDashboard.vue?vue&type=script&lang=ts&"
export * from "./LMSDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39229900",
  null
  
)

export default component.exports